import { useState, useEffect } from 'react';
import Navigation from './Navigation';

export default function Hero() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section className="relative h-screen w-full overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 scale-110">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20luxury%20residential%20architecture%20exterior%20with%20clean%20lines%20and%20large%20windows%2C%20contemporary%20house%20facade%20with%20minimalist%20design%2C%20professional%20real%20estate%20photography%20with%20soft%20natural%20lighting%2C%20architectural%20photography%20style%20with%20neutral%20tones%20and%20sophisticated%20atmosphere%2C%20high-end%20property%20showcase%20with%20elegant%20composition%20and%20refined%20aesthetic&width=1920&height=1080&seq=hero-bg-001&orientation=landscape"
          alt="Hero Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-slate-900/40 via-slate-800/30 to-slate-900/40"></div>
      </div>

      {/* Navigation */}
      <Navigation scrolled={scrolled} />

      {/* Hero Content */}
      <div className="relative h-full flex items-center">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="w-full lg:w-3/5">
            <h1 className="text-white mb-8">
              <div className="text-6xl lg:text-7xl font-black mb-2 tracking-tight" style={{ textShadow: '2px 4px 8px rgba(0,0,0,0.3)' }}>
                理想の住まいを
              </div>
              <div className="text-6xl lg:text-7xl font-black mb-2 tracking-tight" style={{ textShadow: '2px 4px 8px rgba(0,0,0,0.3)' }}>
                一緒に見つける
              </div>
              <div className="text-6xl lg:text-7xl font-black mb-2 tracking-tight" style={{ textShadow: '2px 4px 8px rgba(0,0,0,0.3)' }}>
                パートナー
              </div>
            </h1>
          </div>
        </div>

        {/* Bottom Info Blocks */}
        <div className="absolute bottom-16 left-0 right-0">
          <div className="container mx-auto px-6 lg:px-12">
            <div className="flex justify-between items-end max-w-4xl">
              <div className="text-white">
                <p className="text-lg font-medium">東京23区を中心に</p>
                <p className="text-lg font-medium">500件以上の実績</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
